// extracted by mini-css-extract-plugin
module.exports = {"btn":"index_btn__2FXRL","maxwidth":"index_maxwidth___aPON"};